import { useEffect } from 'react'
import { AddInvestorView } from '../api/investor_views'

const TRACKING_STORAGE_KEY = 'investor_startup_view_tracking'

const getStoredTracking = () => {
  const stored = localStorage.getItem(TRACKING_STORAGE_KEY)
  return stored ? JSON.parse(stored) : {}
}

const setStoredTracking = (tracking) => {
  localStorage.setItem(TRACKING_STORAGE_KEY, JSON.stringify(tracking))
}

const hasStartupViewedInLast24Hours = (startupId) => {
  const tracking = getStoredTracking()
  const lastViewTime = tracking[startupId]

  if (!lastViewTime) return false

  const now = Date.now()
  const dayInMs = 24 * 60 * 60 * 1000

  return (now - lastViewTime) < dayInMs
}

const recordStartupViewTime = (startupId) => {
  const tracking = getStoredTracking()
  tracking[startupId] = Date.now()
  setStoredTracking(tracking)
}

const isAdminUser = () => {
  const getCookie = (name) => {
    const value = `; ${document.cookie}`
    const parts = value.split(`; ${name}=`)
    if (parts.length === 2) return parts.pop().split(';').shift()
    return null
  }

  const adminId = getCookie('X-ADMIN-ID')
  const adminJwt = getCookie('X-ADMIN-JWT')

  return !!(adminId && adminJwt)
}

export const useInvestorViewTracking = (startupId, investorId, tabValue, resized) => {
  const { mutate: trackViewMutation } = AddInvestorView()

  useEffect(() => {
    if ((!startupId || !investorId) || isAdminUser()) return

    const shouldTrack = !hasStartupViewedInLast24Hours(startupId)

    if (shouldTrack) {
      trackViewMutation(
        {
          startup_id: startupId,
          investor_id: investorId,
        },
        {
          onSuccess: () => {
            recordStartupViewTime(startupId)
          },
          onError: (error) => {
            console.error('Failed to track investor view:', error)
          }
        }
      )
    }
  }, [startupId, investorId, tabValue, resized, trackViewMutation])
}
